<div class="row mb-3">
  <div class="col-12 col-md-6">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="partnerId">{{
          'serviceData.form.partner' | translate
        }}</label>
      </div>
      <div class="col-12 col-sm-8">
        <app-partner-typeahead
          name="partnerId"
          id="partnerId"
          class="w-50"
          data-cy="Partner-typeahead"
          [fieldSize]="'medium'"
          [control]="$any(form.controls.partnerId)"
          [disabled]="!!id"
        />
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        <app-validation-error
          for="partnerId"
          translations="validation.generic"
          data-cy="Partner-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 mt-3 mt-md-0">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="doctor">{{ 'serviceData.form.doctor' | translate }}</label>
      </div>
      <div class="col-12 col-sm-8">
        @if (doctors$ | async; as doctors) {
          <app-select
            appInputValidationStatus
            id="doctor"
            data-cy="Doctor-select"
            [placeholder]="
              doctors?.length
                ? ('serviceData.form.placeholders.selectDoctor' | translate)
                : ('serviceData.form.placeholders.noDoctorsAvailable'
                  | translate)
            "
            [formControl]="
              $any(
                form.get('serviceInformation.shared.doctorInformation.doctorId')
              )
            "
          >
            @for (doctor of doctors; track doctor) {
              <app-select-option
                [value]="doctor?.id ?? null"
                [label]="doctor?.name"
              />
            }
          </app-select>
        } @else {
          <app-select
            data-cy="Doctor-select-disabled"
            [placeholder]="
              'serviceData.form.placeholders.selectPartnerFirst' | translate
            "
            [formControl]="
              $any(
                form.get('serviceInformation.shared.doctorInformation.doctorId')
              )
            "
          />
        }
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        <app-validation-error
          for="serviceInformation.shared.doctorInformation.doctorId"
          translations="validation.generic"
          data-cy="Doctor-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>
</div>
